import { format } from 'date-fns';

export function formatDate(
  date: Date | string | null | undefined,
  formatStr: string,
): string | null {
  return date ? format(new Date(date), formatStr) : null;
}

export function getIsoDateString(date: Date | string | null | undefined): string | null {
  return formatDate(date, 'yyyy-MM-dd');
}
